module.exports = __webpack_public_path__ + "img/07logo.39d9f9a0.png";